<template>
  <GasDetailDialog
    :isShowDetail.sync="detailIsShow"
    :title="detailTitle"
    :baseMsg="baseMsg"
    :detailObj="detailObj"
    :deviceType="newDeviceType"
    :deviceProperty="deviceProperty"
    :detailLoading="detailLoading"
    :detailRuleObj="detailRuleObj"
    :detailNetObj="detailNetObj"
    :detailData="detailData"
    :calibrationInfo="calibrationInfo"
    v-bind="$attrs"
    class="comp-sensor-detail"
  ></GasDetailDialog>
</template>

<script>
import GasDetailDialog from './component/GasDetailDialog.vue'
import { gasDetailInfo, getCalibrationInfo } from '@/api/modules/sensor.js'
import bus from '@/utils/bus'
import { shiquArrayConvert } from '@/utils/convert'

export default {
  props: {
    id: {},
    name: {},
    show: {}
  },
  components: {
    GasDetailDialog
  },
  data () {
    return {
      detailData: null,
      baseMsg: [
        {
          text: 'public.belong',
          key: 'url',
          content: ''
        },
        {
          text: $t('integration.mount_'),
          key: 'carrier_name',
          content: ''
        },
        {
          text: $t('integration.gas_code'),
          key: 'gas_code',
          content: ''
        },
        {
          text: $t('integration.gas_type'),
          key: 'type',
          content: ''
        },

        {
          text: $t('integration.gas_status'),
          key: 'status',
          content: ''
        },
        {
          text: 'device.config_status',
          key: 'config_status',
          content: ''
        },
        {
          text: 'public.table_create_time',
          key: 'create_time',
          content: ''
        },
        {
          key: 'description',
          text: $t('public.table_desc'),
          content: ''
        },
        // {
        //   key: 'time_zone',
        //   text: $t('device.time_zone'),
        //   content: ''
        // },
      ],
      detailRuleObj: [
        {
          key: 'collectInterval',
          text: $t('device.sample_interval'),
          isBool: true
        },
        {
          key: 'alarm_threshold',
          text: $t('integration.alarm_threshold'),
          isBool: true
        },
        {
          key: 'normal_report_interval',
          text: $t('device.normal_reporting_interval'),
          isBool: true
        },
        {
          key: 'abnormal_report_interval',
          text: $t('device.abnormal_reporting_interval'),
          isBool: true
        },
        {
          key: 'time_zone',
          text: $t('device.time_zone'),
          isBool: true
        },
      ],
      detailNetObj: [
        {
          key: 'extPanId',
          text: 'Ext Pan ID',
          isBool: true
        },
        {
          key: 'channelPage',
          text: 'Join Attemp',
          isBool: true
        },
        {
          key: 'transmitPower',
          text: 'device.transmit_power',
          isBool: true
        },
        {
          key: 'channelMask',
          text: 'device.channel_mask',
          isBool: true
        },
        {
          key: 'inNetInterval',
          text: 'device.in_net_interval',
          isBool: true
        },
        {
          key: 'devEui',
          text: 'DevEUI',
          isBool: true
        },
        {
          key: 'appEui',
          text: 'AppEUI',
          isBool: true
        },
        {
          key: 'appKey',
          text: 'AppKey',
          isBool: true
        }
      ],
      detailObj: null,
      newDeviceType: {},
      deviceProperty: {},
      detailLoading: false,
      detailIsShow: false,
      detailTitle: '',

      calibrationInfo: {} // 校准详细对象
    }
  },
  watch: {
    detailIsShow (newval) {
      this.$emit('update:show', newval)
    }
  },
  methods: {
    detailFn (id, name) {
      // console.log('row===>', row);
      this.detailTitle = `[${name}]` + this.$t('public.details')
      this.detailIsShow = true
      this.detailLoading = true
      gasDetailInfo(id)
        .then(({ result, state }) => {
          this.detailData = result

          result.gas.pictureBase64 =
            result.gas.pictureBase64 || result.deviceType.pictureBase64
          this.detailObj = result.gas
          this.newDeviceType = result.deviceType
          this.deviceProperty = result.deviceProperty || {}
          const { gas, appConfig, netConfig } = result
          // 基本的数据
          gas.create_time = this.$timetransition(gas.create_time)
          this.baseMsg.forEach(item => {
            for (const newKey in gas) {
              item.key === newKey ? (item.content = gas[newKey]) : null
              if (item.key === 'url') {
                item.content = gas.fullPath
                  ? `${gas.fullPath}/${gas.carrier_name}`
                  : `${gas.scene_name}`
              }
            }
          })

          this.getGenerValueFn(this.detailRuleObj, appConfig)
          // this.getGenerValueFn(this.detailNetObj, netConfig)
        })
        .finally(() => {
          this.detailLoading = false
        })
    },
    getGenerValueFn (array = [], obj) {
      array.forEach(item => {
        item.content = ''
        for (const newKey in obj) {
          // 对时区的显示content做处理
          if(item.key === newKey){
            if(item.key === 'time_zone'){
              item.content =  shiquArrayConvert(obj[newKey])
            }else{
              item.content = obj[newKey]
            }
          }
          // item.key === newKey ? (item.content = obj[newKey]) : null
        }
      })
    },
    getCalibration(id){
      getCalibrationInfo(id, 5).then(res => {
        if (res.state.code === 200) {
            this.calibrationInfo = res.result
        }
      })
    }
  },
  mounted () {
    // 是否插入到body中
    if (this.appendToBody) {
      this.$nextTick(() => {
        const body = document.querySelector('body')
        if (body.append) {
          body.append(this.$el)
        } else {
          body.appendChild(this.$el)
        }

        document.body.removeChild(this.$el)
        this.$destroy()
      })
    }

    bus.$on('gasParam', (id, name) => {
      this.detailFn(id, name)
      this.detailIsShow = true

      // 在获取详情的时候直接获取校准信息，再通过父组件传递给校准tab组件
      this.getCalibration(id)

    })

    // win
    // if (this.$route.query && this.$route.query.id) {
    //     const { id, name } = this.$route.query;
    //     this.detailFn(id, name);
    // }
  },
  beforeDestroy () {
    bus.$off('gasParam')
  }
}
</script>

<style></style>
